import { Organization, WithContext } from 'schema-dts';

export const NERDWALLET_AUTHOR_ID = 1;

export const ORGANIZATION_ID = 'https://www.nerdwallet.com/#organization';

export const ORGANIZATION: WithContext<Organization> = {
  '@context': 'https://schema.org',
  '@id': ORGANIZATION_ID,
  '@type': 'Organization',
  name: 'NerdWallet',
  legalName: 'NerdWallet, Inc.',
  url: 'https://www.nerdwallet.com',
  logo: {
    '@type': 'ImageObject',
    url: 'https://www.nerdwallet.com/assets/img/nw-logos/NW-default_og-image.jpg',
  },
  foundingDate: '2009',
  sameAs: [
    'https://www.facebook.com/NerdWallet',
    'https://twitter.com/NerdWallet',
    'https://www.pinterest.com/nerdwallet',
    'https://nerdwallet.tumblr.com',
    'https://www.linkedin.com/company/nerdwallet',
    'https://plus.google.com/+nerdwallet',
    'https://www.glassdoor.com/Overview/Working-at-NerdWallet-EI_IE687336.11,21.htm',
    'https://www.instagram.com/nerdwallet',
    'https://www.youtube.com/channel/UCTTYccSBNghxcxULTGaO1bA',
  ],
  founder: [
    {
      '@type': 'Person',
      name: 'Tim Chen',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '4150 N Drinkwater Blvd, Suite 200',
    addressLocality: 'Scottsdale',
    addressRegion: 'AZ',
    postalCode: '85251',
    addressCountry: { '@type': 'Country', name: 'US' },
  },
};
